import PatientSummaryPage from './patient-summary-page';

export default PatientSummaryPage;
